<div class="container-fluid mb-3 d-flex flex-column h-100">
  <div class="row">
    <div class="col-8">
      <h2>Client AP Configs</h2>
    </div>
  </div>

  <div class="row my-3 flex-grow-1">
    <div class="col">
      <app-ap-configs-grid [gridName]="'AdminApConfigs'"></app-ap-configs-grid>
    </div>
  </div>
</div>
